<template>
  <section class="relative overflow-hidden border-b border-line">
    <div class="absolute inset-0 bg-hero-glow"></div>
    <div class="absolute inset-0 bg-grid-dark bg-grid [mask-image:radial-gradient(70%_60%_at_50%_0%,black,transparent)]"></div>

    <div class="container-app relative pt-24 sm:pt-32 pb-12 sm:pb-16 text-center animate-fade-in">
      <p class="eyebrow justify-center">
        <i v-if="icon" :class="icon"></i> {{ eyebrow }}
      </p>
      <h1 class="mt-3 text-4xl sm:text-5xl font-extrabold tracking-tight text-white">
        {{ title }}
      </h1>
      <p v-if="subtitle" class="mt-4 max-w-2xl mx-auto text-base sm:text-lg text-ink-muted leading-relaxed">
        {{ subtitle }}
      </p>

      <div v-if="cta || $slots.default" class="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
        <a v-if="cta" :href="ctaHref" class="btn-primary px-6 py-3">
          {{ cta }} <i class="fas fa-arrow-right text-xs"></i>
        </a>
        <a v-if="secondary" :href="secondaryHref" class="btn-secondary px-6 py-3">
          {{ secondary }}
        </a>
        <slot />
      </div>
    </div>
  </section>
</template>

<script>
/* eslint-disable vue/multi-word-component-names */
export default {
  name: "PageHero",
  props: {
    eyebrow: { type: String, default: "" },
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    icon: { type: String, default: "" },
    cta: { type: String, default: "" },
    ctaHref: { type: String, default: "/register" },
    secondary: { type: String, default: "" },
    secondaryHref: { type: String, default: "#" },
  },
};
</script>
